import { render, staticRenderFns } from "./FactFindPensions.vue?vue&type=template&id=9fa80b0e&"
import script from "./FactFindPensions.vue?vue&type=script&lang=ts&"
export * from "./FactFindPensions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports